"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["payment"];

function ErrorMessage(_ref) {
  var payment = _ref.payment,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var _payment$transactions, _payment$transactions2, _payment$transactions3, _payment$transactions4;

    var message = (_payment$transactions = payment === null || payment === void 0 ? void 0 : (_payment$transactions2 = payment['transactions']) === null || _payment$transactions2 === void 0 ? void 0 : (_payment$transactions3 = _payment$transactions2[0]) === null || _payment$transactions3 === void 0 ? void 0 : (_payment$transactions4 = _payment$transactions3['providerData']) === null || _payment$transactions4 === void 0 ? void 0 : _payment$transactions4['error']) !== null && _payment$transactions !== void 0 ? _payment$transactions : null;

    if (message) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['wrapper']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-i'),
        "data-locator": "".concat(props['data-locator'], ".icon")
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['dropdown'],
        "data-locator": "".concat(props['data-locator'], ".dropdown")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['dropdown__label']
      }, message.replace(/\.$/, ''))));
    }

    return null;
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

ErrorMessage.defaultProps = {
  payment: []
};
var _default = ErrorMessage;
exports["default"] = _default;